import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {CompanyBundle, CompanyBundleState} from './interface';
import actions 								from './companyBundleAction';


const initialState: CompanyBundleState = {
	isLoad:         false,
	isLoadPut:      false,
	data:           []
};

export const getCompanyBundleApi = createAsyncThunk('companyBundle/getCompanyBundleApi', actions.getCompanyBundleApi);
export const postCompanyBundleApi = createAsyncThunk('companyBundle/postCompanyBundleApi', actions.postCompanyBundleApi);
export const putCompanyBundleApi = createAsyncThunk('companyBundle/putCompanyBundleApi', actions.putCompanyBundleApi);
export const deleteCompanyBundleApi = createAsyncThunk('companyBundle/deleteCompanyBundleApi', actions.deleteCompanyBundleApi);


export const Reducer = createSlice({
	name:          'companyBundle',
	initialState,
	reducers:      {},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getCompanyBundleApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getCompanyBundleApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload || []
			});
		})
		// --- POST
		.addCase(postCompanyBundleApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(postCompanyBundleApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoad: false});

			const copy = [...state.data];
			copy.push(action.payload);

			return ({
				...state,
				data:   copy,
				isLoad: false
			});
		})
		// --- PUT
		.addCase(putCompanyBundleApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(putCompanyBundleApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoadPut: false});

			const copy: CompanyBundle[] = state.data.map((bundle) => {
				if (bundle._id === action.payload._id)
					return ({...bundle, ...action.payload});
				return bundle;
			});

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		})
		// --- DELETE
		.addCase(deleteCompanyBundleApi.fulfilled, (state, action) => {
			const index = state.data.findIndex(find => find._id === action?.payload);
			const copy = [...state.data];

			if (index !== -1)
				copy.splice(index, 1);
			return ({...state, data: copy});
		});
	}
});

// export const {logout} = Reducer.actions;

export default Reducer.reducer;
